import { useEnquiry } from "./EnquiryContext";

export const StickyCTA = () => {
  const { open, openEnquiry } = useEnquiry();
  if (open) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 z-[75] md:hidden" data-testid="sticky-book-wrap">
      <button
        data-testid="sticky-book-btn"
        onClick={() => openEnquiry()}
        className="w-full bg-gold text-forest-950 font-mono text-xs uppercase tracking-[0.25em] py-4 shadow-2xl shadow-black/60 active:scale-[0.98] transition-transform"
      >
        Book Your Trip
      </button>
    </div>
  );
};
